export const HostDependencyTypes = {
  CockpitHost: Symbol.for('HostCockpit'),
  HubHost: Symbol.for('HostHub'),
  MessagingHost: Symbol.for('MessagingHost'),
  AdventureHost: Symbol.for('HostAdventure'),
  ChallengeHost: Symbol.for('HostChallenge'),
  RacingHost: Symbol.for('HostRacing'),
  KwizHost: Symbol.for('HostKwiz'),
  CockpitApiService: Symbol.for('CockpitApiService'),
  HubApiService: Symbol.for('HubApiService'),
  MessagingApiService: Symbol.for('MessagingApiService'),
};
